(function () {

  'use strict';


  /* =========================================================
     MEDETONE GEO LOCATION BANNER
     MAIN STORE

     DOMAIN:
     https://medetone.com/

     US
     → Suggest United States

     UK
     → Suggest United Kingdom

     Europe
     → No banner

     Rest of World
     → No banner

     Session only.
     No persistent preference cookies.
  ========================================================= */



  var CONFIG = {

    ipinfoToken: '138f68651c3c12',

    apiTimeout: 3500

  };



  var MARKETS = {

    US: {
      name: 'United States',
      url: 'https://us.medetone.com/'
    },

    UK: {
      name: 'United Kingdom',
      url: 'https://uk.medetone.com/'
    }

  };



  /* =========================================================
     SESSION HELPERS
  ========================================================= */

  function getSessionValue(key) {

    try {

      return sessionStorage.getItem(key);

    }

    catch (error) {

      return null;

    }

  }



  function setSessionValue(
    key,
    value
  ) {

    try {

      sessionStorage.setItem(
        key,
        value
      );

    }

    catch (error) {}

  }



  /* =========================================================
     LOCATION CACHE
  ========================================================= */

  function getCachedLocation() {

    try {

      var stored =
        sessionStorage.getItem(
          'medetone_geo_location'
        );


      if (!stored) {

        return null;

      }


      var parsed =
        JSON.parse(stored);


      if (
        !parsed ||
        !parsed.countryCode
      ) {

        return null;

      }


      return parsed;

    }

    catch (error) {

      return null;

    }

  }



  function cacheLocation(
    countryCode,
    countryName
  ) {

    try {

      sessionStorage.setItem(
        'medetone_geo_location',
        JSON.stringify({

          countryCode:
            countryCode,

          countryName:
            countryName

        })
      );

    }

    catch (error) {}

  }



  /* =========================================================
     DESTINATION URL
  ========================================================= */

  function buildDestinationUrl(
    baseUrl
  ) {

    try {

      var destination =
        new URL(baseUrl);


      var currentParams =
        new URLSearchParams(
          window.location.search
        );


      var allowedParams = [

        'utm_source',
        'utm_medium',
        'utm_campaign',
        'utm_term',
        'utm_content',
        'utm_id',

        'gclid',
        'gbraid',
        'wbraid',

        'fbclid',
        'msclkid'

      ];


      for (
        var i = 0;
        i < allowedParams.length;
        i++
      ) {

        var parameter =
          allowedParams[i];


        if (
          currentParams.has(parameter)
        ) {

          destination.searchParams.set(
            parameter,
            currentParams.get(
              parameter
            )
          );

        }

      }


      return destination.toString();

    }

    catch (error) {

      return baseUrl;

    }

  }



  /* =========================================================
     IPINFO
  ========================================================= */

  function lookupVisitorLocation() {

    return new Promise(
      function (
        resolve,
        reject
      ) {

        var cached =
          getCachedLocation();


        if (cached) {

          resolve(cached);

          return;

        }



        if (
          !CONFIG.ipinfoToken ||
          CONFIG.ipinfoToken ===
            'YOUR_IPINFO_TOKEN'
        ) {

          reject(
            new Error(
              'IPinfo token missing'
            )
          );

          return;

        }



        var controller =
          typeof AbortController !==
          'undefined'
            ? new AbortController()
            : null;


        var timer =
          null;


        if (controller) {

          timer =
            window.setTimeout(
              function () {

                controller.abort();

              },
              CONFIG.apiTimeout
            );

        }



        var options = {

          method: 'GET',

          headers: {
            Accept: 'application/json'
          }

        };


        if (controller) {

          options.signal =
            controller.signal;

        }



        fetch(
          'https://api.ipinfo.io/lite/me?token=' +
          encodeURIComponent(
            CONFIG.ipinfoToken
          ),
          options
        )

          .then(
            function (response) {

              if (!response.ok) {

                throw new Error(
                  'IPinfo request failed'
                );

              }


              return response.json();

            }
          )


          .then(
            function (data) {

              if (timer) {

                window.clearTimeout(timer);

              }


              var countryCode =
                String(
                  data.country_code || ''
                )
                  .toUpperCase()
                  .trim();


              var countryName =
                String(
                  data.country || ''
                )
                  .trim();


              if (!countryCode) {

                throw new Error(
                  'No country returned'
                );

              }


              cacheLocation(
                countryCode,
                countryName
              );


              resolve({

                countryCode:
                  countryCode,

                countryName:
                  countryName

              });

            }
          )


          .catch(
            function (error) {

              if (timer) {

                window.clearTimeout(timer);

              }


              reject(error);

            }
          );

      }
    );

  }



  /* =========================================================
     MARKET RULES
  ========================================================= */

  function getSuggestedMarket(
    countryCode
  ) {

    countryCode =
      String(
        countryCode || ''
      )
        .toUpperCase()
        .trim();



    /* US */

    if (
      countryCode === 'US'
    ) {

      return 'US';

    }



    /* UK */

    if (
      countryCode === 'GB'
    ) {

      return 'UK';

    }



    /*
      Europe + Rest of World
      already belong on medetone.com.
    */

    return null;

  }



  /* =========================================================
     INITIALISE
  ========================================================= */

  function initialiseGeoBanner() {

    var banner =
      document.querySelector(
        '[data-med-geo-banner]'
      );


    if (!banner) {

      return;

    }


    var select =
      banner.querySelector(
        '[data-med-geo-select]'
      );


    var detectedCountry =
      banner.querySelector(
        '[data-med-geo-detected-country]'
      );


    var continueButton =
      banner.querySelector(
        '[data-med-geo-continue]'
      );


    var closeButton =
      banner.querySelector(
        '[data-med-geo-close]'
      );


    if (
      !select ||
      !continueButton ||
      !closeButton
    ) {

      return;

    }



    var handledKey =
      'med_geo_handled_MAIN';



    if (
      getSessionValue(
        handledKey
      ) === '1'
    ) {

      return;

    }



    function updateMarketUI(
      marketCode
    ) {

      if (
        !MARKETS[
          marketCode
        ]
      ) {

        return;

      }


      select.value =
        marketCode;

    }



    function showBanner(
      marketCode,
      visitorCountryName
    ) {

      updateMarketUI(
        marketCode
      );


      if (
        detectedCountry
      ) {

        detectedCountry.textContent =
          visitorCountryName ||
          MARKETS[
            marketCode
          ].name;

      }


      banner.hidden =
        false;


      window.requestAnimationFrame(
        function () {

          banner.classList.add(
            'is-visible'
          );

        }
      );

    }



    function hideBanner() {

      banner.classList.remove(
        'is-visible'
      );


      window.setTimeout(
        function () {

          banner.hidden =
            true;

        },
        230
      );

    }



    select.addEventListener(
      'change',
      function () {

        updateMarketUI(
          select.value
        );

      }
    );



    continueButton.addEventListener(
      'click',
      function () {

        var selectedMarket =
          String(
            select.value || ''
          )
            .toUpperCase()
            .trim();


        var market =
          MARKETS[
            selectedMarket
          ];


        if (!market) {

          return;

        }


        setSessionValue(
          handledKey,
          '1'
        );


        window.location.href =
          buildDestinationUrl(
            market.url
          );

      }
    );



    closeButton.addEventListener(
      'click',
      function () {

        setSessionValue(
          handledKey,
          '1'
        );


        hideBanner();

      }
    );



    lookupVisitorLocation()

      .then(
        function (location) {

          var suggestedMarket =
            getSuggestedMarket(
              location.countryCode
            );


          /*
            Europe / Rest of World.

            Already correct.
          */

          if (!suggestedMarket) {

            return;

          }


          showBanner(
            suggestedMarket,
            location.countryName
          );

        }
      )


      .catch(
        function () {

          /*
            Fail silently.
          */

        }
      );

  }



  /* =========================================================
     START
  ========================================================= */

  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initialiseGeoBanner
    );

  }

  else {

    initialiseGeoBanner();

  }

})();